import * as React from 'react';
import { cn } from '@/lib/utils';

/** Wraps the table so wide content scrolls inside itself, never the page body. */
export function TableWrap({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn('scrollbar-thin overflow-x-auto rounded-xl border bg-surface', className)}
      {...props}
    />
  );
}

export const Table = ({ className, ...p }: React.TableHTMLAttributes<HTMLTableElement>) => (
  <table className={cn('w-full text-sm', className)} {...p} />
);

export const THead = ({ className, ...p }: React.HTMLAttributes<HTMLTableSectionElement>) => (
  <thead className={cn('border-b text-ink-muted', className)} {...p} />
);

export const TH = ({ className, ...p }: React.ThHTMLAttributes<HTMLTableCellElement>) => (
  <th className={cn('p-3 text-start font-medium', className)} {...p} />
);

/** `ComponentProps<'tr'>` rather than `HTMLAttributes`, so a row can take a
 *  `ref` — a sortable row has to hand its node to the drag library. */
export const TR = ({ className, ...p }: React.ComponentProps<'tr'>) => (
  <tr className={cn('border-b last:border-0 hover:bg-hover', className)} {...p} />
);

export const TD = ({ className, ...p }: React.TdHTMLAttributes<HTMLTableCellElement>) => (
  <td className={cn('p-3 align-top', className)} {...p} />
);

export function TableEmpty({ colSpan, children }: { colSpan: number; children: React.ReactNode }) {
  return (
    <tr>
      <td colSpan={colSpan} className="p-10 text-center text-ink-muted">
        {children}
      </td>
    </tr>
  );
}
